export default __webpack_public_path__ + "static/media/donut_2.e23f789b.png";